import { change } from 'redux-form';
import getEnvironmentSuffix from '../../shared/helpers/getEnvironmentSuffix';

import { anowVendorApiRequest } from '../../shared/libs/anowApiRequest';
import mapRequiredHiddenFields from '../../shared/libs/mapRequiredHiddenFields';

function fulfillFormConfig(
  formConfig,
  companyDetails,
  requiresPreAuthorizedPayment = false,
  guestRequiresPreAuthorizedPayment = false,
) {
  return {
    type: 'FULFILL_FORM_CONFIG',
    payload: mapRequiredHiddenFields(formConfig),
    companyDetails,
    requiresPreAuthorizedPayment,
    guestRequiresPreAuthorizedPayment,
  };
}

export function fulfillPaymentDetails({ clientSecret, paymentOptions }) {
  return {
    type: 'FULFILL_PAYMENT_DETAILS',
    clientSecret,
    paymentOptions,
  };
}

export function fulfillPaymentCustomerId(paymentCustomerId) {
  return {
    type: 'FULFILL_PAYMENT_CUSTOMER_ID',
    paymentCustomerId,
  };
}

export function updatePaymentsDetails(paymentOptions) {
  return {
    type: 'UPDATE_PAYMENT_DETAILS',
    paymentOptions,
  };
}

function fulfillDropdownLists(
  propertyType,
  reportPurpose,
  reportType,
  inspectionTypes,
  valueApproaches,
) {
  return {
    type: 'FULFILL_DROPDOWN_LISTS',
    propertyType,
    reportPurpose,
    reportType,
    inspectionTypes,
    valueApproaches,
  };
}

// eslint-disable-next-line import/prefer-default-export
export function getFormConfig(slug) {
  return (dispatch) => anowVendorApiRequest({
    url: `/company/${slug}`,
  })
    .then(({ data }) => data)
    .then(async (companyDetails) => {
      const {
        orderForm,
        requiresPreAuthorizedPayment,
        disableGuestOrderForm,
        guestRequiresPreAuthorizedPayment,
        ...rest
      } = companyDetails;
      if (!window.isAuthenticated && disableGuestOrderForm) {
        window.location.href = `https://login${getEnvironmentSuffix()}.anow.com/?returnUrl=${
          window.location.href
        }`;
        return {};
      }
      dispatch(
        fulfillFormConfig(
          orderForm,
          rest,
          requiresPreAuthorizedPayment,
          guestRequiresPreAuthorizedPayment,
        ),
      );
      const propertyTypesData = await anowVendorApiRequest({
        url: `company/${slug}/property_types`,
      })
        .then(({ data }) => data)
        .catch(() => []);
      const reportPurposeData = await anowVendorApiRequest({
        url: `company/${slug}/appraisal_purposes`,
      })
        .then(({ data }) => data)
        .catch(() => []);
      const reportTypesData = await anowVendorApiRequest({
        url: `company/${slug}/report_types`,
      })
        .then(({ data }) => data)
        .catch(() => []);
      const inspectionTypesData = await anowVendorApiRequest({
        url: `company/${slug}/inspection_types`,
      })
        .then(({ data }) => data)
        .catch(() => []);
      const valueApproachesData = await anowVendorApiRequest({
        url: `company/${slug}/value_approaches`,
      })
        .then(({ data }) => data)
        .catch(() => []);
      const propertyTypes = propertyTypesData.map((el, i) => ({
        value: el.name,
        label: el.name,
        sequence: i,
      }));
      const reportPurposes = reportPurposeData.map((el, i) => ({
        value: el.name,
        label: el.name,
        sequence: i,
      }));
      const inspectionTypes = inspectionTypesData.map((el) => ({
        ...el,
        value: el.name,
        label: el.name,
        sequence: el.id,
      }));
      const valueApproaches = valueApproachesData.map((el) => ({
        ...el,
        value: el.name,
        label: el.name,
        sequence: el.id,
      }));
      const reportTypes = reportTypesData.map((el, i) => ({
        ...el,
        value: el.name,
        label: el.description || el.name,
        sequence: i,
        clientFee: el.clientFee,
      }));
      dispatch(
        fulfillDropdownLists(
          propertyTypes,
          reportPurposes,
          reportTypes,
          inspectionTypes,
          valueApproaches,
        ),
      );
      return null;
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.log(e.message);
      window.location.href = '/notFound';
      return {};
    });
}

export function getCurrentCompanyProfile() {
  return (dispatch) => {
    if (window.isAuthenticated) {
      anowVendorApiRequest({
        url: `company/${window.companyGuid}`,
      }).then(({ data }) => {
        dispatch(change('WizardOrderForm', 'anowUser', data));
      });
    }
  };
}

export function initPaymentsDetails(withCard = false) {
  return async (dispatch) => {
    try {
      const { data: paymentOptions } = await anowVendorApiRequest({
        url: 'customer/settings/preauth',
      });
      const {
        data: { clientSecret },
      } = await anowVendorApiRequest({
        url: 'customer/settings/preauth/secret',
      });
      dispatch(fulfillPaymentDetails({ clientSecret, paymentOptions }));
      if (withCard) {
        if (Array.isArray(paymentOptions) && paymentOptions.length > 0) {
          dispatch(
            change(
              'WizardOrderForm',
              'paymentMethodId',
              paymentOptions[0].paymentMethodId,
            ),
          );
        }
      }
    } catch (e) {
      dispatch(
        fulfillPaymentDetails({ clientSecret: null, paymentOptions: [] }),
      );
    }
  };
}

export function removePaymentCard(paymentId) {
  return {
    type: 'REMOVE_PAYMENT_ID',
    paymentId,
  };
}

/// customer/settings/preauth/secret?name=abc&email=a@b.com
